import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ButtonModern } from ".";
//import ToggleButton from "react-toggle-button";

const MatchAdmin = ({ match, setMatch, saveMatch }) => {
  const [matchInfo, setMatchInfo] = useState(match);
  const [hideAW, setHideAW] = useState(false);

  const submitMatch = () => {
    console.log(`save match: ${JSON.stringify(matchInfo)}`);

    saveMatch(matchInfo);
  };

  const template = `Mapa 1: xxxxx
Civ ${matchInfo.player_a_username}: xxxxx
Civ ${matchInfo.player_b_username}: xxxxx
Ganador: xxxxx

Mapa 2: xxxxx
Civ ${matchInfo.player_a_username}: xxxxx
Civ ${matchInfo.player_b_username}: xxxxx
Ganador: xxxxx

Mapa 3: xxxxx
Civ ${matchInfo.player_a_username}: xxxxx
Civ ${matchInfo.player_b_username}: xxxxx
Ganador: xxxxx`;

  useEffect(() => {
    if (!matchInfo.comments) {
      setMatch({ ...matchInfo, comments: template });
      setMatchInfo({ ...matchInfo, comments: template });
    }
    // eslint-disable-next-line
  }, [matchInfo]);

  return (
    <Wrapper>
      <div className="column">
        <h2>Estado</h2>
        <div className="status-fields">
          {/* <ToggleButton
            inactiveLabel={"❌"}
            activeLabel={"✔️"}
            value={matchInfo.status === "FINISHED"}
            onToggle={(value) => {
              setMatchInfo({
                ...matchInfo,
                status: !value ? "FINISHED" : "NOT_STARTED",
              });
            }}
          /> */}
          <span>{matchInfo.status}</span>
        </div>

        <h2>Fecha</h2>
        <div className="date-edition">
          <div>Date picker</div>
        </div>

        <h2>Resultado</h2>
        <article>
          <div className="match-result">
            <div className="username column-3 first-column">
              {matchInfo.player_a_username}
            </div>
            <div className="column-3">
              <input
                className="input-text-field"
                type="text"
                placeholder="0"
                value={
                  matchInfo.player_a_result || matchInfo.player_a_result === 0
                    ? matchInfo.player_a_result
                    : ""
                }
                name="player_a_result"
                onChange={(event) =>
                  setMatchInfo({
                    ...matchInfo,
                    player_a_result: event.target.value,
                  })
                }
              />{" "}
              -
              <input
                className="input-text-field"
                type="text"
                placeholder="0"
                value={
                  matchInfo.player_b_result || matchInfo.player_b_result === 0
                    ? matchInfo.player_b_result
                    : ""
                }
                name="player_b_result"
                onChange={(event) =>
                  setMatchInfo({
                    ...matchInfo,
                    player_b_result: event.target.value,
                  })
                }
              />
            </div>
            <div className="username column-3 final-column">
              {matchInfo.player_b_username}
            </div>
          </div>
          <div className={`match-result-aw ${hideAW ? "hide-aw" : ""}`}>
            <input
              type="checkbox"
              defaultChecked={matchInfo.player_a_aw ? true : false}
              name="aw-player-a"
              onChange={(event) =>
                setMatchInfo({
                  ...matchInfo,
                  player_a_aw: event.target.checked ? "AW" : "",
                })
              }
            />
            <span>AW</span>
            <input
              type="checkbox"
              defaultChecked={matchInfo.player_b_aw ? true : false}
              name="aw-player-b"
              onChange={(event) =>
                setMatchInfo({
                  ...matchInfo,
                  player_b_aw: event.target.checked ? "AW" : "",
                })
              }
            />
          </div>
          <div className="match-result-aw">
            <span>Empate administrativo</span>
            <input
              type="checkbox"
              defaultChecked={matchInfo.player_b_aw ? true : false}
              name="aw-player-b"
              onChange={(event) => {
                setMatchInfo({
                  ...matchInfo,
                  player_a_result: 0,
                  player_b_result: 0,
                  player_b_aw: event.target.checked ? "AW" : "",
                  player_a_aw: event.target.checked ? "AW" : "",
                });
                setHideAW(!hideAW);
              }}
            />
          </div>
          <div className="links-picks">
            Link draft mapas:{" "}
            <input
              className="input-text-field-big"
              type="text"
              placeholder="https://www.aoe2cm.net/spectate/xxxxxx"
              value={matchInfo.map_draft ? matchInfo.map_draft : ""}
              name="map_pick"
              onChange={(event) =>
                setMatchInfo({ ...matchInfo, map_draft: event.target.value })
              }
            />
          </div>
          <div className="links-picks">
            Link draft civis:{" "}
            <input
              className="input-text-field-big"
              type="text"
              placeholder="https://www.aoe2cm.net/spectate/xxxxxx"
              value={matchInfo.civ_draft ? matchInfo.civ_draft : ""}
              name="civ_pick"
              onChange={(event) =>
                setMatchInfo({ ...matchInfo, civ_draft: event.target.value })
              }
            />
          </div>
          <div className="links-picks">
            Comentarios (públicos):{" "}
            <textarea
              className="input-text-field-large"
              type="text"
              placeholder="Comentarios"
              value={matchInfo.comments ? matchInfo.comments : ""}
              name="comments"
              onChange={(event) =>
                setMatchInfo({ ...matchInfo, comments: event.target.value })
              }
            />
          </div>
          <ButtonModern
            text="Guardar"
            marginLeft="2rem"
            fontSize="1.5em"
            onClick={submitMatch}
          />
        </article>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  height: 120vh;
  .status-fields {
    display: flex;
    margin-bottom: 2rem;
    * {
      margin-right: 1rem;
    }
  }

  .hide-aw {
    display: none !important;
  }
  .date-edition {
    margin-bottom: 4rem;
  }
  .match-result {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
  }
  .match-result-aw {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    span {
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }
  .column-3 {
    width: 33%;
    text-align: center;
  }
  .first-column {
    text-align: left;
  }
  .final-column {
    text-align: right;
  }
  .input-text-field {
    background: transparent;
    height: 2rem;
    width: 1.2rem;
    border: 0;
    border-bottom: 1px solid var(--clr-grey-1);
    outline: 0;
    color: var(--clr-grey-1);
    text-align: center;
    transition: border-color 0.2s;
    font-size: 24px;
  }

  .input-text-field-big {
    background: transparent;
    height: 2rem;
    width: 100%;
    border: 0;
    border-bottom: 1px solid var(--clr-grey-1);
    outline: 0;
    color: var(--clr-grey-1);
    text-align: left;
    transition: border-color 0.2s;
    font-size: 16px;
  }
  .input-text-field-large {
    background: transparent;
    width: 100%;
    height: 260px;
    border: 1px solid var(--clr-grey-1);
    padding: 0.2rem;
    outline: 0;
    color: var(--clr-grey-1);

    transition: border-color 0.2s;
  }
  .links-picks {
    width: 100%;
    margin-top: 1.5rem;
  }
  p {
    font-size: 16px;
  }
  .draft-link a {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 1rem;
  }
  .background-video {
    width: 100%;
    height: 80vh;
    object-fit: cover;
    position: absolute;
    z-index: -1;
  }
  .container {
    margin-top: 8rem;
    width: 100%;

    position: absolute;
    display: flex;
    justify-content: center;
  }

  .breadcrumb {
    width: 60%;
    top: -6rem;
    left: 4rem;
    position: absolute;
    .separator {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  .draft {
    width: 95%;
    position: absolute;
    display: flex;
    justify-content: space-around;
  }

  .column {
    //width: 34%;
  }

  .map-turns {
    display: flex;
  }

  .draft-turn {
    margin: 0.2rem;
  }

  /* Date Picker */
  .date-picker {
    color: var(--clr-grey-1);
    cursor: pointer;
  }

  .react-datetime-picker {
    display: inline-flex;
    position: relative;
    color: var(--clr-grey-1);
  }
  .react-datetime-picker,
  .react-datetime-picker *,
  .react-datetime-picker *:before,
  .react-datetime-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-datetime-picker--disabled {
    background-color: #f0f0f0;
    color: var(--clr-grey-1);
  }
  .react-datetime-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
  }
  .react-datetime-picker__inputGroup {
    min-width: calc(4px + (4px * 3) + 0.54em * 6 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    cursor: pointer;
  }
  .react-datetime-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  .react-datetime-picker__inputGroup__input {
    min-width: 0.54em;
    height: calc(100% - 2px);
    position: relative;
    padding: 1px;
    border: 0;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
    color: var(--clr-grey-1);
    cursor: pointer;
  }
  .react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datetime-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  .react-datetime-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  .react-datetime-picker__inputGroup__amPm {
    font: inherit;
    -moz-appearance: menulist;
  }
  .react-datetime-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  .react-datetime-picker__button:enabled {
    cursor: pointer;
  }
  .react-datetime-picker__button:enabled:hover
    .react-datetime-picker__button__icon,
  .react-datetime-picker__button:enabled:focus
    .react-datetime-picker__button__icon {
    stroke: #0078d7;
  }
  .react-datetime-picker__button:disabled .react-datetime-picker__button__icon {
    stroke: #6d6d6d;
  }
  .react-datetime-picker__button svg {
    display: inherit;
  }
  .react-datetime-picker__calendar,
  .react-datetime-picker__clock {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
  }
  .react-datetime-picker__calendar--closed,
  .react-datetime-picker__clock--closed {
    display: none;
  }
  .react-datetime-picker__calendar {
    width: 350px;
    max-width: 100vw;
  }
  .react-datetime-picker__calendar .react-calendar {
    border-width: thin;
  }
  .react-datetime-picker__clock {
    width: 200px;
    height: 200px;
    max-width: 100vw;
    padding: 25px;
    background-color: white;
    border: thin solid #a0a096;
  }
  .react-datetime-picker__clear-button svg {
    stroke: var(--clr-grey-1);
  }
  .react-datetime-picker__calendar-button svg {
    stroke: var(--clr-grey-1);
  }

  /* calendar */
  .react-calendar {
    width: 350px;
    max-width: 100%;
    background: white;
    border: 1px solid #a0a096;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__tile--now {
    background: #ffff76;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
  }
  .react-calendar__tile--hasActive {
    background: #76baff;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
  }
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }

  /* Clock */
  .react-clock {
    display: block;
    position: relative;
  }
  .react-clock,
  .react-clock *,
  .react-clock *:before,
  .react-clock *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-clock__face {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid black;
    border-radius: 50%;
  }
  .react-clock__hand {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 50%;
  }
  .react-clock__hand__body {
    position: absolute;
    background-color: black;
    transform: translateX(-50%);
  }
  .react-clock__mark {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 50%;
  }
  .react-clock__mark__body {
    position: absolute;
    background-color: black;
    transform: translateX(-50%);
  }
  .react-clock__mark__number {
    position: absolute;
    left: -40px;
    width: 80px;
    text-align: center;
  }
  .react-clock__second-hand__body {
    background-color: red;
  }
`;

export default MatchAdmin;
